import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, message, Modal, Upload } from 'antd'
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBoxVertical/Types";
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum } from '@/utils/utils'
import { useDictModel } from '@/views/base/dict/dictModel'
import { usePurchaseDrDetailsModel } from './purchaseDrDetailsModel'
import { ISCMPurchaseDrFormFields } from '../../purchaseDrTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { purchaseDrService } from '../../purchaseDrService'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'
import { ResourceAuthEnum } from '@/types/VrmResoureAuthEnum'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadOutlined } from '@ant-design/icons'
import { fileDownload } from '@/utils/exportFile'
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface'
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const { beShopDs, shopDs,
        user: { userName, shopCode },
    } = useGlobalModel()
    const { fetchFmsShopList } = useGlobalModel(() => [])
    const {
        editFormVal,
        addFormVal,
        addGoodsList,
        editGoodsList,
        editDesc,
        addDesc,
        inWhConfirm,
        buttonControl,
        saveBtnLoading,
        saveBtn,
        setPrint,
        insertPDr,
        updatePDr,
        setAddFormVal,
        setEditGoodsList,
        setAddGoodsList,
        getPDrDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        verifyGoods,
        setAddOutShopCode,
        formComputeRule,
        exportPDrdetail,
        setSaveBtnLoading,
    } = usePurchaseDrDetailsModel()
    const { selectedNavId, replaceNav, findNav, addNav } = useNavModel()
    const { getSelectedDictOne, getTreeNodeOne, getTreeSelectOne } = useDictModel(() => [])
    const [more, setMore] = useState<boolean>(true) //控制更多按钮
    const { getTreeNodeName } = useDictModel();

    //根据状态判断是否可以进行修改 调入单：待调入、待调出可以修改
    const [isDisabled, setIsDisabled] = useState(false)
    useEffect(() => {
        if (mode === 'add') {
            setIsDisabled(false)
        } else if (mode === 'edit') {
            if (editFormVal?.status !== DictCodeEnmu.TRANSFER_STATUS_INIT && editFormVal?.status !== DictCodeEnmu.TRANSFER_STATUS_OUT) {
                setIsDisabled(true)
            } else {
                setIsDisabled(false)
            }
        } else {
            setIsDisabled(true)
        }
    }, [editFormVal])
    //编辑
    useEffect(() => {
        if (mode === 'edit') {
            //没有缓在调用详情接口
            if (!editFormVal.id) {
                getPDrDetailOne(id)
                // .then((res) => {
                //     getShopinUnitDetail(res.shopCode)
                //     getShopOutUnitDetail({ label: res.outShopName, value: res.outShopCode }, true)
                // })
                return
            }
            // editFormVal.outShopCode && getShopOutUnitDetail({ label: editFormVal.outShopName ?? '', value: editFormVal.outShopCode }, true)
            // editFormVal.shopCode && getShopinUnitDetail(editFormVal.shopCode)
        }
        // if (mode === 'add') {
        //     addFormVal.outShopCode && getShopOutUnitDetail({ label: addFormVal.outShopName ?? '', value: addFormVal.outShopCode }, true)
        //     addFormVal.shopCode && getShopinUnitDetail(addFormVal.shopCode)
        // }
    }, [mode])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            // console.log(findNav("16-1-1"))
            !findNav('16-1-1') && resetAddCatch()
            !findNav('16-1-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //监听商品变化的时候 设置表单金额
    useEffect(() => {
        let values: ISCMPurchaseDrFormFields = formRef.current?.getFieldsValue()
        setFormAmount(values)
    }, [addDesc, editDesc])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    /**
     * 表单或者商品操作。 （设置金额，回显表单，设置缓存,禁用库房操作）
     */
    const setFormAmount = (values: ISCMPurchaseDrFormFields, changedValues?: { [key: string]: any }) => {
        let { amountAll, actualAmount } = mode === 'edit' ? editDesc : addDesc
        let {
            favorableAmount, //整单优惠
            discountRate, //整单下浮
            aggregateAmount, //应付金额
            paidAmount, //已付金额
            discountTotalAmount, //优惠总额
        } = values
        discountRate = switchNum1(discountRate, '0')
        favorableAmount = switchNum1(favorableAmount, '0')
        actualAmount = +formatNum(actualAmount)
        amountAll = +formatNum(amountAll)
        //应付金额=sum(总计)*（1-整单下浮）-整单优惠）
        let isZero = +formatNum(amountAll * (1 - +discountRate) - +favorableAmount)
        aggregateAmount = isZero < 0 ? `-${isZero}` : isZero

        //优惠总额 = 所有商品的合计 - 总计 - 整单优惠 - 整单下浮优惠
        discountTotalAmount = formatNum(actualAmount - isZero)

        paidAmount = formatNum(paidAmount)
        // setWsConfirmDisable(true);
        saveCache(changedValues ? changedValues : { discountTotalAmount, aggregateAmount, favorableAmount, discountRate, paidAmount })
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        if ('favorableAmount' in changedValues || 'discountRate' in changedValues) {
            setFormAmount(values)
        } else {
            setFormAmount(values, { ...changedValues })
        }
    }

    //表单提交
    const onSubmit = () => {
        if (!verifyGoods(mode)) return
        if (!formComputeRule(mode)) return

        // let filterGoodsShelf =
        //     mode === 'add'
        //         ? addGoodsList.filter((item) => !!!item.inShelfCode || !!!item.inWarehouseCode)
        //         : editGoodsList.filter((item) => !!!item.inShelfCode || !!!item.inWarehouseCode)
        // if (!!filterGoodsShelf.length) {
        //     message.warning('没有对应调入仓库和调入货位')
        //     return false
        // }
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.inMd5 = file?.uid
                    val.inName = file?.name
                } else {
                    val.inMd5 = ''
                    val.inName = ''
                }
                // val.inNote=val.inNote?val.inNote:val.note
                val.fileList = null
                mode === 'edit'
                    ? updatePDr(val)
                    : insertPDr(val).then((res) => {
                        if (res) {
                            resetEditCatch()
                            replaceNav('16-1-1', '16-1-2', { id: res ?? '', mode: 'edit' })
                        }
                    })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    const [inUnitBeList, setinUnitBeList] = useState<ISelectOption[]>([]) //调入站点对应的关联实体
    //回显选中调入站点带出来的数据
    const getShopinUnitDetail = async (shopId: string) => {
        let { retData } = await purchaseDrService.queryShopUnitBe(shopId as string)
        if (retData && retData.id) {
            if (retData.bentityList && retData.bentityList.length) {
                setinUnitBeList(retData.bentityList.map((item) => ({ label: item.name ?? '', value: item.code ?? '' })))
            } else {
                setinUnitBeList([])
                message.warning('调入站点对应的核算单位没有关联实体')
            }
        } else {
            setinUnitBeList([])
            message.warning('调入站点没有关联的核算单位')
        }
    }

    const [outUnitBeList, setOutUnitBeList] = useState<ISelectOption[]>([]) //调出站点对应的关联实体
    //回显选中调出站点带出来的数据
    const getShopOutUnitDetail = async (option: ISelectOption, echo: boolean = false) => {
        let { retData } = await purchaseDrService.queryShopUnitBe((option.id as string) ?? (option.value as string))
        let data = {
            outShopCode: option.value,
            outShopName: option.label,
            outShopId: option.id,
            transferTypeName: option.branch === 'scm' ? '备品调拨' : '其它调拨',
            transferTypeCode: option.branch === 'scm' ? DictCodeEnmu.TRANSFER_TYPE_BP : DictCodeEnmu.TRANSFER_TYPE_OTHERS,
            outBentityName: undefined, //每次选中的时候对应的实体置空
            outBentityCode: undefined,
            contact: undefined,
            phone: undefined,
            branchOut: option.branch,
        }
        if (retData && retData.id) {
            if (retData.bentityList && retData.bentityList.length) {
                setOutUnitBeList(retData.bentityList.map((item) => ({ label: item.name ?? '', value: item.code ?? '' })))
            } else {
                setOutUnitBeList([])
                message.warning('调出站点对应的核算单位没有关联实体')
            }
            //回显时不用执行一下操作
            if (echo) return
            saveCache({
                ...data,
                contact: retData.contact,
                phone: retData.phone,
            })
        } else {
            saveCache(data)
            setOutUnitBeList([])
            message.warning('调出站点没有关联的核算单位')
        }
    }
    //调出站点
    const outShopChange = (value: string, option: ISelectOption) => {
        mode === 'add' && setAddOutShopCode(!!value)
        mode === 'add' ? setAddGoodsList([]) : setEditGoodsList([])
        if (option && option.value) {
            saveCache({
                outShopCode: option.code,
                outShopName: option.label,
                outShopId: option.value,
            })
        }
    }
    //调出实体
    const outBeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ outBentityName: option.label, outBentityCode: option.value })
    }
    //调入实体
    const inBeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ bentityName: option.label, bentityCode: option.value })
    }
    //调拨类行
    const transferTypeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ transferTypeName: option.label, transferTypeCode: option.value })
    }
    const onRefresh = debounce(() => {
        getPDrDetailOne(id).then((res) => message.success('已刷新'))
    }, 500)
    const whConFirm = () => {
        if (!verifyGoods(mode)) return
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.inMd5 = file?.uid
                    val.inName = file?.name
                } else {
                    val.inMd5 = ''
                    val.inName = ''
                }
                val.fileList = null
                inWhConfirm(val)
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }
    const redeployIn = () => {
        setAddFormVal({ ...editFormVal, code: undefined, transferInCode: undefined, transferOutCode: undefined, createUser: userName, applyTime: undefined })
        addNav('16-1-1', { id: '', mode: 'add' })
        setAddGoodsList(
            editGoodsList.map((item) => {
                let { id, transferCode, ...params } = item
                return { ...params, id: '' }
            })
        )
        setAddOutShopCode(true)
    }
    const rightChildren = (
        <>
            {mode === 'edit' ? (
                <>
                    {/* <Button className="mr-5" type="primary" shape="round" onClick={() => exportPDrdetail()}>
                        导出
                    </Button> */}
                    <YhAuth resCode={ResourceAuthEnum.P_DR_ED_PRINT}>
                        <Button className="mr-5" type="primary" shape="round" onClick={() => setPrint(true)}>
                            打印
                        </Button>
                    </YhAuth>
                    <Button className="mr-5" type="primary" shape="round" onClick={onRefresh}>
                        刷新
                    </Button>
                    <YhAuth resCode={ResourceAuthEnum.P_DR_AD_APPLY}>
                        <Button
                            className="mr-5"
                            type="primary"
                            shape="round"
                            loading={saveBtnLoading}
                            disabled={editFormVal.status === DictCodeEnmu.TRANSFER_STATUS_IN}
                            onClick={debounce(() => {
                                onSubmit()
                            }, 500)}
                        >
                            {saveBtnLoading ? '保存中' : '保存'}
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_DR_ED_DR}>
                        <Button
                            className="mr-5"
                            type="primary"
                            shape="round"
                            disabled={editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_OUT || saveBtn}
                            onClick={debounce(() => {
                                whConFirm()
                            })}
                        >
                            调入
                        </Button>
                    </YhAuth>
                    {editFormVal.status === 'transfer-status.reject' && (
                        <Button
                            className="mr-5"
                            type="primary"
                            shape="round"
                            onClick={debounce(() => {
                                redeployIn()
                            })}
                        >
                            重新调入
                        </Button>
                    )}
                </>
            ) : (
                <YhAuth resCode={ResourceAuthEnum.P_DR_AD_APPLY}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        loading={saveBtnLoading}
                        onClick={debounce(() => {
                            onSubmit()
                        }, 500)}
                    >
                        {saveBtnLoading ? '请调中' : '请调'}
                    </Button>
                </YhAuth>
            )}
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => {
                    replaceNav(selectedNavId, '16-1')
                    setSaveBtnLoading(false)
                }}
            >
                返回
            </Button>
        </>
    )

    const onPreview = (file: UploadFile<any>, branch = "vrm") => {
        const { uid, name } = file
        const type = name.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={branch !== 'ci' ? getBaseImgLookUrl(uid) : `https://file-server.yunhaochefu.com/image/${uid}`} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }
    const [shopList, setShopList] = useState<ISelectOption[]>([])
    useEffect(() => {
        fetchFmsShopList('').then(arr => {
            setShopList(arr)
        })
    }, [])
    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '调入单号',
            //     fieldName: 'code',
            //     disable: true,
            //     placeholder: '自动生成',
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入站点',
                fieldName: 'shopName',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调出站点',
                fieldName: 'outShopCode',
                onSelectChange: outShopChange,
                rules: [{ required: true, message: '请选择调出站点' }],
                disable: mode === 'edit' && (editFormVal?.status !== DictCodeEnmu.TRANSFER_STATUS_IN && editFormVal?.status !== DictCodeEnmu.TRANSFER_STATUS_OUT),
                options: shopDs.map((item: any) => {
                    if (shopCode == item.code) {
                        return { ...item, disabled: true }
                    } else {
                        return item
                    }
                }),
                // options: shopList.map(item => {
                //     if (shopCode == item.code) {
                //         return { ...item, disabled: true }
                //     } else {
                //         return item
                //     }
                // }),
                // defaultQuery: mode === 'edit' ? editFormVal.outShopName : addFormVal.outShopName,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '整单下浮',
                fieldName: 'discountRate',
                hidden: true,
                rules: [
                    { required: true, message: '该项为必填' },
                    { pattern: /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/, message: '请输入0-1' },
                ],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '应付金额',
                fieldName: 'aggregateAmount',
                disable: true,
                hidden: true,
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "结算类型",
                //     fieldName: "payType",
                //     disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入备注',
                fieldName: 'inNote',
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入员',
                fieldName: 'transferIn',
                disable: true,
                // hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出员',
                fieldName: 'transferOut',
                disable: true,
                // hidden: more
            }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "联系电话",
                //     fieldName: "phone",
                //     rules: [{ required: true, message: "请输入联系电话" }]
                // }, {
                //     type: FormItemTypeEnum.Button,
                //     fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                //     fieldName: "",
                //     span: 2,
                //     labelCol: { span: 16, offset: 8 },
                // }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单员',
                fieldName: 'applier',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调入实体',
                fieldName: 'bentityCode',
                options: beShopDs,
                onSelectChange: inBeChange,
                rules: [{ required: true, message: '请选择调入实体' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调出实体',
                fieldName: 'outBentityCode',
                onSelectChange: outBeChange,
                options: beShopDs,
                rules: [{ required: true, message: '请选择调出实体' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出备注',
                fieldName: 'note',
                // fieldName: editFormVal.inNote?"inNote":"note",
                disable: true,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '整单优惠',
                fieldName: 'favorableAmount',
                hidden: true,
                rules: [{ pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '已付金额',
                fieldName: 'paidAmount',
                disable: true,
                hidden: true,
            },
            {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "联系人",
                //     fieldName: "contact",
                //     rules: [{ required: true, message: "请输入联系人" }]
                // }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '优惠总额',
                fieldName: 'discountTotalAmount',
                disable: true,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入日期',
                fieldName: 'transferInTime',
                disable: true,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出日期',
                fieldName: 'transferOutTime',
                disable: true,
                // hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单日期',
                fieldName: 'applyTime',
                disable: true,

                // hidden: more
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调拨类型',
                fieldName: 'transferTypeCode',
                onSelectChange: transferTypeChange,
                options: getSelectedDictOne(DictCodeEnmu.TRANSFER_TYPE),
                disable: true,
                rules: [{ required: true, message: '请选择调拨类型' }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 12,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            disabled={isDisabled}
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            {!isDisabled && (
                                <>
                                    <Button icon={<UploadOutlined />}>选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>
                            )}
                        </Upload>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '调出附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 12,
                hidden: mode === 'add',
                formItem: (
                    <Form.Item name="fileInList" label="调出附件" valuePropName="fileInList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        {editFormVal.fileInList && (editFormVal.fileInList.length > 0) &&
                            <div style={{ position: 'relative', height: '66px', padding: '20px', border: '1px solid #90a4fe', borderRadius: '5px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                onClick={() => {
                                    onPreview(editFormVal.fileInList[0], mode === 'edit' ? editFormVal.branchOut : addFormVal.branchOut)
                                }}
                            >
                                <FontIcon
                                    style={{ fontSize: '24px' }}
                                    type="icon-tupian"
                                />
                                <span style={{ marginLeft: '20px' }}>{editFormVal.fileInList[0].name}</span>
                            </div>}
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单人',
                fieldName: 'createUser',
                disable: true,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                disable: true,
                hidden: true,
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "制单日期",
                //     fieldName: "createTime",
                //     disable: true,
                //     hidden: more
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "修改人",
                //     fieldName: "updateUser",
                //     disable: true,
                //     hidden: more
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "修改日期",
                //     fieldName: "updateTime",
                //     disable: true,
                //     hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'bentityName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入站点Code',
                fieldName: 'shopCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出站点名称',
                fieldName: 'outShopName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出站点id',
                fieldName: 'outShopId',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出实体名称',
                fieldName: 'outBentityName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调拨类型名称',
                fieldName: 'transferTypeName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入分支',
                fieldName: 'branchIn',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出分支',
                fieldName: 'branchOut',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '状态',
                fieldName: 'status',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出单号',
                fieldName: 'transferOutCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入单号',
                fieldName: 'transferInCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '成本金额',
                fieldName: 'costAmount',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '毛利',
                fieldName: 'grossProfit',
                hidden: true,
            },
        ],
    }

    const poFromConfig: IYhFormBox<ISCMPurchaseDrFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        disabled: isDisabled,
        boxs: [baseFormItem],
    }

    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        调入单:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{editFormVal.code ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(editFormVal?.status && getTreeNodeName(editFormVal?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
